import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PageContainer from "../Layout/PageContainer";
import StorageCategoryForm from "./StorageCategoryForm";
import StorageCategoryService from "../../redux/services/storageCategory.service";
toast.configure();

const StorageCategory = (props) => {
  const navigate = useNavigate();

  const { id } = useParams();

  const [storageCategoryDetail, setStorageCategoryDetail] = useState({});

  useEffect(() => {
    if (!/\d+/.test(id)) {
      navigate("/storageCategory/list");
    }
  }, [id, navigate]);

  useEffect(() => {
    if (props.currentUser.roleId === 2) {
      navigate("/dashboard");
    }
  }, [props.currentUser, navigate]);

  const getStorageCategory = (id) => {
    StorageCategoryService.get(id)
      .then((response) => {
        setStorageCategoryDetail(response.data.storageCategory);
      })
      .catch((error) => {
        toast(error, {
          transition: Slide,

          closeButton: true,

          autoClose: 3000,

          position: "top-right",

          type: "error",
        });
      });
  };

  useEffect(() => {
    if (id != "" && /\d+/.test(id)) getStorageCategory(id);
  }, [id]);

  return (
    <PageContainer
      pageTitleIcon="pe-7s-tools icon-gradient bg-plum-plate"
      pageHeading={
        id != "" && /\d+/.test(id)
          ? "Edit Storage category"
          : "Add Storage category"
      }
      pageSubTitle={
        id != "" && /\d+/.test(id)
          ? "Edit storage category information"
          : "Save storage category information"
      }
    >
      <StorageCategoryForm storageCategoryDetail={storageCategoryDetail} />
    </PageContainer>
  );
};

export default StorageCategory;
